var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 18.3333H5.83334C4.45262 18.3333 3.33334 17.214 3.33334 15.8333M3.33334 15.8333C3.33334 14.4526 4.45262 13.3333 5.83334 13.3333H14.6667C15.7712 13.3333 16.6667 12.4379 16.6667 11.3333V3.33329C16.6667 2.41282 15.9205 1.66663 15 1.66663H5.83334C4.45262 1.66663 3.33334 2.78591 3.33334 4.16663V15.8333ZM15 13.3333V18.3333M6.66667 1.66663V13.3333",
    stroke: "#525D6A",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.b80d72a0a2d41be57702ac305561b95f.svg";
export { ForwardRef as ReactComponent };